// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../public/images/icons/upload-cloud.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../../public/images/icons/small-slide-arrow.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.c-uploadimage {
  background: #F4F9FF;
  border-radius: 14px;
  padding: 55px 36px 30px;
}
.c-uploadimage-label {
  font-weight: 600;
  font-size: 20px;
  line-height: 23px;
  color: #050F2F;
  margin-bottom: 0;
}
.c-uploadimage-btn {
  background: #F4F9FF;
  border: 2px dashed #7B91D5;
  border-radius: 14px;
  padding: 2rem 2.5rem 2.5rem;
  margin: 20px 0;
  text-align: center;
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;
  color: #515562;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.c-uploadimage-btn:before {
  content: "";
  width: 72px;
  height: 72px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat;
  background-size: 100%;
  display: flex;
}
.c-uploadimage-btn .file-upload {
  display: none;
}
.c-uploadimage-text {
  display: flex;
  font-weight: 400;
  font-size: 13px;
  line-height: 15px;
  color: #515562;
  margin-top: 13px;
}
.c-uploadimage-text strong {
  font-weight: 600;
}
.c-uploadimage-slide {
  padding-top: 10px;
  position: relative;
}
.c-uploadimage-slide-prev {
  background: #E3E3E3;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  left: -15px;
  top: 50%;
  transform: translateY(-50%);
}
.c-uploadimage-slide-prev:after {
  content: "";
  width: 15px;
  height: 15px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat;
  background-size: 100%;
}
.c-uploadimage-slide-prev:hover {
  background: #fff;
}
.c-uploadimage-slide-prev:hover:after {
  filter: brightness(0) invert(0);
}
.c-uploadimage-slide-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 10px;
}
.c-uploadimage-slide-item {
  background: #D9D9D9;
  border-radius: 6px;
  overflow: hidden;
  flex: 1 1 auto;
  max-width: 18%;
  height: 63px;
}
.c-uploadimage-slide-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.c-uploadimage-slide-next {
  background: #E3E3E3;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  right: -15px;
  top: 50%;
  transform: translateY(-50%);
}
.c-uploadimage-slide-next:after {
  content: "";
  width: 15px;
  height: 15px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat;
  background-size: 100%;
  transform: rotate(180deg);
}
.c-uploadimage-slide-next:hover {
  background: #fff;
}
.c-uploadimage-slide-next:hover:after {
  filter: brightness(0) invert(0);
}

.c-binfo-title {
  font-weight: 500;
  font-size: 20px;
  line-height: 23px;
  color: #050F2F;
  margin-bottom: 33px;
  margin-top: 20px;
}

span.error {
  width: 100%;
  color: red;
}`, "",{"version":3,"sources":["webpack://./src/components/Spaces/styles/_upload-image.scss"],"names":[],"mappings":"AAAA;EACG,mBAAA;EACA,mBAAA;EACA,uBAAA;AACH;AAAG;EACG,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;AAEN;AAGG;EACG,mBAAA;EACA,0BAAA;EACA,mBAAA;EACA,2BAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AADN;AAEM;EACG,WAAA;EACA,WAAA;EACA,YAAA;EACA,6DAAA;EACA,qBAAA;EACA,aAAA;AAAT;AAEM;EACG,aAAA;AAAT;AAGG;EACG,aAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;AADN;AAEM;EACG,gBAAA;AAAT;AAGG;EACG,iBAAA;EACA,kBAAA;AADN;AAEM;EACG,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;AAAT;AACS;EACG,WAAA;EACA,WAAA;EACA,YAAA;EACA,6DAAA;EACA,qBAAA;AACZ;AACS;EACG,gBAAA;AACZ;AAAY;EACG,+BAAA;AAEf;AAEM;EACG,aAAA;EACA,eAAA;EACA,8BAAA;EACA,SAAA;AAAT;AAEM;EACG,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,cAAA;EACA,YAAA;AAAT;AACS;EACG,WAAA;EACA,YAAA;EACA,iBAAA;AACZ;AAEM;EACG,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,YAAA;EACA,QAAA;EACA,2BAAA;AAAT;AACS;EACG,WAAA;EACA,WAAA;EACA,YAAA;EACA,6DAAA;EACA,qBAAA;EACA,yBAAA;AACZ;AACS;EACG,gBAAA;AACZ;AAAY;EACG,+BAAA;AAEf;;AAKG;EACG,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;AAFN;;AAMA;EACG,WAAA;EACA,UAAA;AAHH","sourcesContent":[".c-uploadimage{\n   background: #F4F9FF;\n   border-radius: 14px;\n   padding: 55px 36px 30px;\n   &-label{\n      font-weight: 600;\n      font-size: 20px;\n      line-height: 23px;\n      color: #050F2F;\n      margin-bottom: 0;\n      \n   }\n   &-wrap{\n   }\n   &-btn{\n      background: #F4F9FF;\n      border: 2px dashed #7B91D5;\n      border-radius: 14px;\n      padding: 2rem 2.5rem 2.5rem;\n      margin: 20px 0;\n      text-align: center;\n      font-weight: 600;\n      font-size: 16px;\n      line-height: 19px;\n      color: #515562;\n      position: relative;\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      &:before{\n         content: '';\n         width: 72px;\n         height: 72px;\n         background: url(../../../../public//images/icons/upload-cloud.svg) no-repeat;\n         background-size: 100%;\n         display: flex;\n      }\n      .file-upload{\n         display: none;\n      }\n   }\n   &-text{\n      display: flex;\n      font-weight: 400;\n      font-size: 13px;\n      line-height: 15px;\n      color: #515562;\n      margin-top: 13px;\n      strong{\n         font-weight: 600;\n      }\n   }\n   &-slide{\n      padding-top: 10px;\n      position: relative;\n      &-prev{\n         background: #E3E3E3;\n         border-radius: 50%;\n         width: 24px;\n         height: 24px;\n         display: flex;\n         align-items: center;\n         justify-content: center;\n         position: absolute;\n         left: -15px;\n         top: 50%;\n         transform: translateY(-50%);\n         &:after{\n            content: '';\n            width: 15px;\n            height: 15px;\n            background: url(../../../../public//images/icons/small-slide-arrow.svg) no-repeat;\n            background-size: 100%;\n         }\n         &:hover{\n            background: #fff;\n            &:after{\n               filter: brightness(0) invert(0);\n            }\n         }\n      }\n      &-list{\n         display: flex;\n         flex-wrap: wrap;\n         justify-content: space-between;\n         gap: 10px\n      }\n      &-item{\n         background: #D9D9D9;\n         border-radius: 6px;\n         overflow: hidden;\n         flex: 1 1 auto;\n         max-width: 18%;\n         height: 63px;\n         img{\n            width: 100%;\n            height: 100%;\n            object-fit: cover;\n         }\n      }\n      &-next{\n         background: #E3E3E3;\n         border-radius: 50%;\n         width: 24px;\n         height: 24px;\n         display: flex;\n         align-items: center;\n         justify-content: center;\n         position: absolute;\n         right: -15px;\n         top: 50%;\n         transform: translateY(-50%);\n         &:after{\n            content: '';\n            width: 15px;\n            height: 15px;\n            background: url(../../../../public//images/icons/small-slide-arrow.svg) no-repeat;\n            background-size: 100%;\n            transform: rotate(180deg);\n         }\n         &:hover{\n            background: #fff;\n            &:after{\n               filter: brightness(0) invert(0);\n            }\n         }\n      }\n   }\n}\n.c-binfo{\n   &-title{\n      font-weight: 500;\n      font-size: 20px;\n      line-height: 23px;\n      color: #050F2F;\n      margin-bottom: 33px;\n      margin-top: 20px;\n   }\n}\n\nspan.error {\n   width: 100%;\n   color: red;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
